import { render, staticRenderFns } from "./EditMsgType.vue?vue&type=template&id=1f092853&scoped=true&"
import script from "./EditMsgType.vue?vue&type=script&lang=ts&"
export * from "./EditMsgType.vue?vue&type=script&lang=ts&"
import style0 from "./EditMsgType.vue?vue&type=style&index=0&id=1f092853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f092853",
  null
  
)

export default component.exports